import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'

export const DoubleOptInAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.settings_organization}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
